<template>
  <chart-container :title="title">
    <apexchart
      type="area"
      :height="computedOptions.height"
      :options="computedOptions"
      :series="computedSeries"
    />
  </chart-container>
</template>

<script>
import _merge from "lodash.merge";

import ChartContainer from "@/components/dashboard/ChartContainer.vue";
import { ApexBaseChartOptions } from "@/commons/chart-commons.js";

export default {
  components: {
    ChartContainer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  computed: {
    computedOptions() {
      const localOptions = {
        height: this.height || ApexBaseChartOptions.height,
        chart: {
          stacked: true,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        fill: {
          type: "gradient",
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
          },
        },
        xaxis: {
          type: "datetime",
        },
      };
      return Object.freeze(
        _merge({}, ApexBaseChartOptions, localOptions, this.options.plotOptions)
      );
    },
    computedSeries() {
      return this.options.series;
    },
  },
};
</script>